// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"0f2cb5de","335":"06eddbab","797":"24fb891e","827":"a8977fa6","977":"e7bbd13a"}[chunkId] + ".chunk.js";
};